import { BreadCrumbs, HomeIcon } from '@isdd/idsk-ui-kit/index'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { setDocumentTitle } from '@isdd/metais-common/utils/utils'

import { getCiHowToBreadCrumb, useGetEntityParamsFromUrl } from '@/componentHelpers/ci'
import { MainContentWrapper } from '@/components/MainContentWrapper'
import { useCiCreateEntityHook } from '@/hooks/useCiCreateEntity.hook'
import { CreateTrainingEntityView } from '@/components/views/ci/create/CreateTrainingEntityView'

const CreateTrainingEntityPage: React.FC = () => {
    const { t } = useTranslation()
    const { entityName } = useGetEntityParamsFromUrl()
    const ciCreateData = useCiCreateEntityHook({ entityName: entityName ?? '' })
    setDocumentTitle(t('titles.ciCreateEntity', { ci: ciCreateData.ciTypeName }))

    return (
        <>
            <BreadCrumbs
                withWidthContainer
                links={[
                    { label: t('breadcrumbs.home'), href: '/', icon: HomeIcon },
                    ...getCiHowToBreadCrumb(entityName ?? '', t),
                    { label: t('titles.ciList', { ci: ciCreateData.ciTypeName }), href: `/ci/${entityName}` },
                    {
                        label: t('breadcrumbs.ciCreateEntity', { entityName: ciCreateData.data.attributesData.ciTypeData?.name }),
                        href: `/ci/create`,
                    },
                ]}
            />
            <MainContentWrapper>
                <CreateTrainingEntityView {...ciCreateData} />
            </MainContentWrapper>
        </>
    )
}

export default CreateTrainingEntityPage
